import fetch from 'lib/decorated-fetch'
import getUrl from 'lib/url'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import useOptimisticStatus, {
  useStatusCountUpdater,
} from 'Components/hooks/use-optimistic-status'
import { useCallback, useMemo } from 'react'
import useLoginCheckCallback from 'Components/hooks/use-login-check-callback'

export interface ICollectParams {
  group_id?: string
}

function collect(collectParams: ICollectParams) {
  return fetch(
    getUrl(
      `/motor/pc/ugc/collect/user_collect?${serializeObject(collectParams)}`
    )
  ).then((res) => {
    return res?.data?.result
  })
}

function unCollect(collectParams: ICollectParams) {
  return fetch(
    getUrl(
      `/motor/pc/ugc/collect/user_uncollect?${serializeObject(collectParams)}`
    )
  ).then((res) => {
    return res?.data?.result
  })
}

function useToggleCollect({
  id,
  collected,
  collectCount,
}: {
  id: string
  collected?: boolean
  collectCount?: number
}) {
  const { begin, rollback, curStatus, curCount } = useStatusCountUpdater({
    status: collected,
    count: collectCount,
  })

  return {
    update: useOptimisticStatus<[boolean, number]>({
      execute: useLoginCheckCallback(
        useCallback(
          ([curStatus]) => {
            return (curStatus ? collect : unCollect)({
              group_id: id,
            })
          },
          [id]
        ),
        useMemo(
          () => ({
            enter_method: 'favorite',
          }),
          []
        )
      ),
      begin,
      rollback,
    }),
    curStatus,
    curCount,
  }
}

export default useToggleCollect
